<template>
  <canvas
    ref="captchaCanvas"
    :width="width"
    :height="height"
    class="captcha-canvas"
    @click="refreshCaptcha"
  ></canvas>
</template>

<script>
export default {
  name: 'Captcha',
  props: {
    width: {
      type: Number,
      default: 120
    },
    height: {
      type: Number,
      default: 40
    },
    codeLength: {
      type: Number,
      default: 4
    }
  },
  data () {
    return {
      captchaCode: ''
    }
  },
  mounted () {
    this.refreshCaptcha()
  },
  methods: {
    refreshCaptcha () {
      this.captchaCode = this.generateCode()
      this.drawCaptcha()
      this.$emit('update:code', this.captchaCode)
    },
    generateCode () {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let code = ''
      for (let i = 0; i < this.codeLength; i++) {
        code += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return code
    },
    drawCaptcha () {
      const canvas = this.$refs.captchaCanvas
      const ctx = canvas.getContext('2d')
      
      ctx.clearRect(0, 0, this.width, this.height)
      
      ctx.fillStyle = '#f0f0f0'
      ctx.fillRect(0, 0, this.width, this.height)
      
      for (let i = 0; i < 5; i++) {
        ctx.strokeStyle = this.randomColor(150, 200)
        ctx.beginPath()
        ctx.moveTo(Math.random() * this.width, Math.random() * this.height)
        ctx.lineTo(Math.random() * this.width, Math.random() * this.height)
        ctx.stroke()
      }
      
      for (let i = 0; i < 30; i++) {
        ctx.fillStyle = this.randomColor()
        ctx.beginPath()
        ctx.arc(
          Math.random() * this.width,
          Math.random() * this.height,
          1,
          0,
          2 * Math.PI
        )
        ctx.fill()
      }
      
      const chars = this.captchaCode.split('')
      const charWidth = this.width / (chars.length + 1)
      
      chars.forEach((char, index) => {
        ctx.save()
        const x = charWidth * (index + 1)
        const y = this.height / 2 + 5
        const angle = (Math.random() - 0.5) * 0.4
        ctx.translate(x, y)
        ctx.rotate(angle)
        ctx.font = `${this.height * 0.6}px Arial`
        ctx.fillStyle = this.randomColor(50, 150)
        ctx.textBaseline = 'middle'
        ctx.fillText(char, 0, 0)
        ctx.restore()
      })
    },
    randomColor (min, max) {
      const r = this.randomNum(min || 0, max || 255)
      const g = this.randomNum(min || 0, max || 255)
      const b = this.randomNum(min || 0, max || 255)
      return `rgb(${r},${g},${b})`
    },
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    validate (inputCode) {
      return inputCode.toLowerCase() === this.captchaCode.toLowerCase()
    }
  }
}
</script>

<style scoped>
.captcha-canvas {
  cursor: pointer;
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/views/login/Captcha.vue